// this.$emit('pick', 
// { area_id: this.area.id, area_name: this.area.name, code: this.carcode[1,this.carcodes.length-1]})
<template>
    <div>
        <van-cell :title="required ? '车牌号(必填)': '车牌号码'" :value="(area_name? area_name:'') + (code? code: '')" @click="visible=true"/>
        <van-popup
            id="carno"
            v-model="visible"
            position="bottom"
            :style="{ height: '80%' }">
            <div>
                <van-grid :column-num="8" class="car-code">
                    <van-grid-item
                        v-for="(it, idx) in carcodes"
                        :key="idx"
                        :text="it"
                        clickable />
                </van-grid>
                <van-grid :column-num="10" class="areashort">
                    <van-grid-item
                        v-for="it in areas"
                        :key="it.id"
                        :text="it.name"
                        :class="it.id==area.id? 'sel': ''"
                        @click="pickarea(it)"
                        clickable />
                </van-grid>
                <van-grid :column-num="10" class="areashort">
                    <van-grid-item
                        v-for="it in codes"
                        :key="it"
                        :text="it"
                        @click="pickcode(it)"
                        clickable />
                </van-grid>
                <van-row type="flex" justify="space-between">
                    <van-button type="default" size="small" @click="cancel">取消</van-button>
                    <van-button type="primary" size="small" @click="ok">确定</van-button>
                </van-row>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { Popup, Row, Col, PasswordInput, Grid, GridItem, Tag, Field, Cell, Button } from 'vant';
import { AreaShortApi } from '@/api/base'
export default {
    name: 'CarNo',
    props: ['code', 'area_name', 'area_id', 'required'],
    components: {
        [Popup.name]: Popup,
        [Row.name]: Row,
        [Col.name]: Col,
        [PasswordInput.name]: PasswordInput,
        [Grid.name]: Grid,
        [GridItem.name]: GridItem,
        [Tag.name]: Tag,
        [Field.name]: Field,
        [Cell.name]: Cell,
        [Button.name]: Button
    },
    data() {
        return {
            visible: false,
            showKeyboard: false,
            area: {id: 21, name: '粤'},
            areas: [],   // 选择部分
            codes: ['1','2','3','4','5','6','7','8','9','0',
                'A','B','C','D','E','F','G','H','I','J','K',
                'L','M','N','O','P','Q','R','S','T','U','V',
                'W','X','Y','Z'],
            carcodes: ['粤']
        }
    },
    mounted() {
        this.getareashort()
    },
    methods: {
        show() {
            this.getareashort()
            this.visible = true
        },
        getareashort() {
            var that = this
            that.axios.get(AreaShortApi).then((ret) => {
                that.areas = ret
                that.area = ret[0]
            })
        },
        pickarea(it) {
            this.area = it
            this.carcodes[0] = it.name
        },
        pickcode(it) {
            if (this.carcodes.length>0 && this.carcodes.length < 8) {
                this.carcodes.push(it)
            }
        },
        cancel() {
            if (this.carcodes.length>0) {
                this.carcodes = [this.carcodes[0]]
            }
            this.$emit('pick', null)
            this.visible = false
        },
        ok() {
            const codes = this.carcodes.slice(1)
            this.$emit('pick', { 
                area_id: this.area.id, 
                area_name: this.area.name, 
                code: codes.join('')})
            this.visible = false
        }
    }
}
</script>

<style lang="less" scope>
#carno {
    .areashort {
        .sel {
            font-weight: bold;
            background: #f7f8fa;
            color: red;
        }
        .normal {
            font-weight: normal;
        }
    }
    .curareashort {
        font-weight: bold;
        background-color: #f7f8fa;
        width: 60px;
        font-size: 2em;
        color: red;
    }
}
</style>